import { Permission } from 'shared'
import { useGlobalState } from 'context/GlobalStateContext'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { EJType, useTypesTableContext } from '../../../../TypesTableContext'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { CreateEditFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useCreateEjTypeMutation } from '../../../../../../../../../../../schema'
import { errorHandler } from 'hooks/errorHandler'

export function useCreate(): CreateHeaderActionOptions<EJType> {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { refetch, fetching } = useTypesTableContext()
  const [create, { loading: creating }] = useCreateEjTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createEJType: {
        type: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: creating || fetching,
    entity: 'Type',
    permission: Permission.CreateEJType,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      onOk: async ({
        name,
        allowanceDescription,
        users,
        reportTypeId,
      }: CreateEditFormItemsValues) => {
        if (!projectId) return errorHandler('Project id must be defined')

        await create({
          variables: {
            input: {
              projectId,
              name,
              userIds: users?.map(({ value }) => value.toString()),
              reportTypeId: reportTypeId,
              // Required field, so using bang
              allowanceDescription: allowanceDescription!,
            },
          },
        })

        refetch()
      },
    },
  }
}
